import { useSessionContext } from '@shared/hooks'
import { Flex, Input, Typography } from 'antd'
import { useTranslation } from 'react-i18next'

type Props = {
  title: string
  onSearch?: (search: string) => void
  searchValue?: string
  renderActionButton?: (isAllowRole: boolean) => React.ReactNode
}

export const TitleActionButton = ({
  title,
  searchValue,
  onSearch,
  renderActionButton
}: Props) => {
  const { t } = useTranslation()
  const { isAdmin } = useSessionContext()

  return (
    <Flex align="center" justify="space-between">
      <Flex gap="8px" align="center">
        <Typography.Title level={5}>{title}</Typography.Title>
        {onSearch && (
          <div>
            <Input.Search
              value={searchValue}
              onChange={(v) => onSearch(v.target.value.trim())}
              onClear={() => onSearch('')}
              allowClear
              placeholder={t('common.search')}
            />
          </div>
        )}
      </Flex>

      {renderActionButton?.(isAdmin)}
    </Flex>
  )
}
